"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState, type JSX } from "react";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import ProxyActions from "../proxy/list/ProxyActions";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import ProxyCreateAction from "../proxy/create-action/ProxyCreateAction";
import CommonChangeAnimation from "@/components/utils/animation/CommonChangeAnimation";
import { PROFILE_PROXY_AVAILABLE_ACTIONS } from "@/entities/IProxy";
import Link from "next/link";
enum VIEW_TYPE {
  LIST = "LIST",
  CREATE_NEW = "CREATE_NEW",
}
export default function ProxyListItem(t0) {
  const $ = _c(67);
  const {
    isSelf,
    profileProxy,
    profile
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== connectedProfile?.id || $[1] !== profileProxy.created_by.id) {
    t1 = () => connectedProfile?.id === profileProxy?.created_by?.id;
    $[0] = connectedProfile?.id;
    $[1] = profileProxy.created_by.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getIsGrantor = t1;
  const [isGrantor, setIsGrantor] = useState(getIsGrantor());
  const [viewType, setViewType] = useState(VIEW_TYPE.LIST);
  let t2;
  if ($[3] !== isGrantor || $[4] !== isSelf || $[5] !== profileProxy.actions || $[6] !== viewType) {
    t2 = () => {
      const haveActionsLeftToAdd = PROFILE_PROXY_AVAILABLE_ACTIONS.filter(action => profileProxy.actions.filter(a => a.action_type === action).length === 0).length > 0;
      return haveActionsLeftToAdd && isGrantor && isSelf && viewType === VIEW_TYPE.LIST;
    };
    $[3] = isGrantor;
    $[4] = isSelf;
    $[5] = profileProxy.actions;
    $[6] = viewType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const getCanAddNewAction = t2;
  let t3;
  if ($[8] !== getCanAddNewAction) {
    t3 = getCanAddNewAction();
    $[8] = getCanAddNewAction;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const [canAddNewAction, setCanAddNewAction] = useState(t3);
  let t4;
  if ($[10] !== getIsGrantor) {
    t4 = () => {
      setIsGrantor(getIsGrantor());
    };
    $[10] = getIsGrantor;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== connectedProfile || $[13] !== profileProxy) {
    t5 = [profileProxy, connectedProfile];
    $[12] = connectedProfile;
    $[13] = profileProxy;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  if ($[15] !== getCanAddNewAction) {
    t6 = () => {
      setCanAddNewAction(getCanAddNewAction());
    };
    $[15] = getCanAddNewAction;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isGrantor || $[18] !== isSelf || $[19] !== profileProxy || $[20] !== viewType) {
    t7 = [isGrantor, isSelf, viewType, profileProxy];
    $[17] = isGrantor;
    $[18] = isSelf;
    $[19] = profileProxy;
    $[20] = viewType;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  useEffect(t6, t7);
  let t8;
  if ($[22] !== isSelf || $[23] !== profile || $[24] !== profileProxy) {
    t8 = <ProxyActions profileProxy={profileProxy} profile={profile} isSelf={isSelf} />;
    $[22] = isSelf;
    $[23] = profile;
    $[24] = profileProxy;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t10;
  let t9;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setViewType(VIEW_TYPE.LIST);
    t10 = () => setViewType(VIEW_TYPE.LIST);
    $[26] = t10;
    $[27] = t9;
  } else {
    t10 = $[26];
    t9 = $[27];
  }
  let t11;
  if ($[28] !== profileProxy) {
    t11 = <div className="tw-mt-4"><ProxyCreateAction profileProxy={profileProxy} onActionCreated={t9} onCancel={t10} /></div>;
    $[28] = profileProxy;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t8) {
    t12 = {
      [VIEW_TYPE.LIST]: t8,
      [VIEW_TYPE.CREATE_NEW]: t11
    };
    $[30] = t11;
    $[31] = t8;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const components = t12;
  const t13 = `/${profileProxy.created_by.handle}/proxy`;
  let t14;
  if ($[33] !== profileProxy.created_by.pfp) {
    t14 = profileProxy.created_by.pfp ? <img src={profileProxy.created_by.pfp} alt="Profile picture" className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-white/30" /> : <div className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-white/30" />;
    $[33] = profileProxy.created_by.pfp;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== profileProxy.created_by.handle) {
    t15 = <p className="tw-mb-0 tw-flex-auto tw-font-semibold tw-text-iron-50 hover:tw-text-iron-400 tw-text-base tw-transition tw-duration-300 tw-ease-out">{profileProxy.created_by.handle}</p>;
    $[35] = profileProxy.created_by.handle;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t14 || $[38] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-3">{t14}{t15}</div>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t13 || $[41] !== t16) {
    t17 = <Link href={t13}>{t16}</Link>;
    $[40] = t13;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-300" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  const t19 = `/${profileProxy.granted_to.handle}/proxy`;
  let t20;
  if ($[44] !== profileProxy.granted_to.pfp) {
    t20 = profileProxy.granted_to.pfp ? <img src={profileProxy.granted_to.pfp} alt="Profile picture" className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-white/30" /> : <div className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-white/30" />;
    $[44] = profileProxy.granted_to.pfp;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== profileProxy.granted_to.handle) {
    t21 = <p className="tw-mb-0 tw-flex-auto tw-font-semibold tw-text-iron-50 tw-text-base hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out">{profileProxy.granted_to.handle}</p>;
    $[46] = profileProxy.granted_to.handle;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t20 || $[49] !== t21) {
    t22 = <div className="tw-flex tw-items-center tw-gap-x-3">{t20}{t21}</div>;
    $[48] = t20;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t19 || $[52] !== t22) {
    t23 = <div className="tw-flex tw-w-full tw-gap-x-4"><Link href={t19} className="tw-group">{t22}</Link></div>;
    $[51] = t19;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== canAddNewAction) {
    t24 = canAddNewAction && <button type="button" onClick={() => setViewType(VIEW_TYPE.CREATE_NEW)} className="tw-flex tw-items-center tw-justify-center tw-relative tw-bg-iron-50 tw-px-3 tw-py-2 tw-text-sm tw-leading-5 tw-font-semibold tw-text-iron-700 tw-border tw-border-solid tw-border-iron-50 tw-rounded-lg hover:tw-bg-iron-300 hover:tw-border-iron-300 tw-transition tw-duration-300 tw-ease-out tw-text-nowrap"><svg className="tw-w-5 tw-h-5 tw-mr-1.5 -tw-ml-1" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Add A Proxy</span></button>;
    $[54] = canAddNewAction;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t24) {
    t25 = <div>{t24}</div>;
    $[56] = t24;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t17 || $[59] !== t23 || $[60] !== t25) {
    t26 = <div className="tw-h-9 tw-mt-3 tw-flex tw-items-center tw-gap-x-3 tw-py-1">{t17}{t18}{t23}{t25}</div>;
    $[58] = t17;
    $[59] = t23;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  const t27 = components[viewType];
  let t28;
  if ($[62] !== t27) {
    t28 = <div><CommonChangeAnimation>{t27}</CommonChangeAnimation></div>;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t26 || $[65] !== t28) {
    t29 = <div>{t26}{t28}</div>;
    $[64] = t26;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  return t29;
}